<div class="layout-column custom-panel full-height">
  <form class="flex layout-column" #availabilityForm="ngForm" (ngSubmit)="onSubmit(availabilityForm)">
    <!-- Header -->
    <div class="layout-row layout-align-start-center header">
      <bringoz-button type="tertiary"
                      (onClick)="onCancel()">
        <bringoz-icon iconName="arrow-left"></bringoz-icon>
      </bringoz-button>
      <span class="flex"></span>
      <span class="br-body-2 font-weight-600 primary-100" translate>Mark as Available</span>
      <span class="flex"></span>
      <bringoz-button type="tertiary"
                      (onClick)="onCancel()">
        <bringoz-icon iconName="close"></bringoz-icon>
      </bringoz-button>
    </div>

    <hr class="main-divider">

    <!-- Content Area -->
    <div class="layout-column flex padding-10">
      <!-- Time Selection -->
      <div class="layout-row layout-align-start-center time-inputs-container">
        <app-bringoz-datetime-range class="flex"
                                    [timeOnly]="true"
                                    [from]="fromTime"
                                    [to]="toTime"
                                    [min]="dayStartTime"
                                    [max]="dayEndTime"
                                    [isRequired]="true"
                                    (onRangeChange)="onRangeChange($event)">
        </app-bringoz-datetime-range>
      </div>

      <!-- Error Message -->
      <div *ngIf="errorMessage" class="layout-row margin-top-10">
        <span class="br-body-2 error-text">{{ errorMessage }}</span>
      </div>
    </div>

    <!-- Action Buttons -->
    <hr class="main-divider">
    <div class="layout-row layout-align-start-center padding-5">
      <bringoz-button type="tertiary"
                      (onClick)="onCancel()">
        <span class="br-body-1 font-weight-400 gray-101" translate>Cancel</span>
      </bringoz-button>
      <span class="flex"></span>
      <bringoz-button type="tertiary"
                      buttonType="submit"
                      [isDisabled]="!!errorMessage">
        <span class="br-body-1 font-weight-400 blue-104" translate>Submit</span>
      </bringoz-button>
    </div>
  </form>
</div>

